<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="650"
      max-height="90%"
      min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t("common.company_details") }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin" :loading="savingInProgress">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="requisites_form">
          <v-container fluid>
            <v-row align="center">
              <v-col
                  sm="12"
              >
                <v-text-field
                    v-model="tmpRequisites.urik_name"
                    :label="$t('common.legal_name')"
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                ></v-text-field>
                <v-text-field
                    v-if="client_lang==='ru'"
                    :label="$t('common.inn')"
                    v-model="tmpRequisites.inn"
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                ></v-text-field>
                <v-text-field
                    v-if="client_lang==='ru'"
                    :label="$t('common.kpp')"
                    v-model="tmpRequisites.kpp"
                ></v-text-field>
                <v-text-field
                    v-if="client_lang==='en'"
                    :label="$t('common.address')"
                    v-model="tmpRequisites.address"
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin" small :loading="savingInProgress">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn small
            class="white--text"
            elevation="0"
            color="success"
            @click="save"
            :loading="savingInProgress"
        >
          {{ $t("common.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapFields} from "vuex-map-fields";

export default {
  name: "RequisitesWindow",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tmpRequisites:{
      urik_name: null,
      inn: 0,
      kpp: 0,
      address: null
    }
  }),
  computed:{
    ...mapFields("auth", ["requisites", "client_lang", "savingInProgress"]),
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods:{
    save(){
      if (this.$refs['requisites_form'].validate()) {
        this.$store.dispatch("auth/updateRequisites", this.tmpRequisites).then(result=>{
          if(result){
            this.$emit("hide");
          }
        })
      }
    },
    hideWin() {
      this.isVisibleWindow = false;
      this.tmpRequisites = {
        urik_name: null,
        inn: null,
        kpp: null,
        address: null
      };
    },
  },
  watch:{
    isVisible(to){
      if(to){
        if(this.requisites) {
          this.tmpRequisites = this.requisites;
        }
      }
    }
  }
}
</script>

<style scoped>

</style>